// @flow
import React, { PureComponent } from 'react';
import { withHelmet } from 'infrastructure/seo/Helmet';
import { STATUS_DEFAULT } from 'constants/statusConstants';
import type { Status } from 'types/Status';
import type { JoueurType } from 'types/Joueur';
import type { BlocContent } from 'types/NewsletterBloc';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import CompetitionInternationalesArticles from 'components/competitionsInternationales/competitionsInternationalesArticles';
import Loading from 'components/fragments/Loading';
import BackgroundImage from 'components/fragments/BackgroundImage';
import { youtubeDurationToTime } from 'utils/socialUtils';
import { formatFullDate } from 'utils/dateUtils';
import { Link } from 'react-router-dom';
import type { CompetitionInternationale } from 'types/competitionsInternationales';
import './competitionsInternationalesPlayer.css';
export type StateProps = {
  data: CompetitionInternationale,
  joueur: JoueurType,
  joueurStatus: Status
};

type OwnProps = {
  match: {
    params: {
      joueurSlug: string
    }
  }
};
export type DispatchProps = {
  fetchJoueur: (slug: string) => void
};

type Props = StateProps & OwnProps & DispatchProps;

class Joueur extends PureComponent<Props> {
  componentDidMount() {
    this.props.fetchJoueur(this.props.match.params.joueurSlug);
  }

  componentDidUpdate(prevProps: Props) {
    const { joueurSlug } = this.props.match.params;
    if (prevProps.match.params.joueurSlug !== joueurSlug) {
      this.props.fetchJoueur(joueurSlug);
    }
  }

  renderTrueBlocs = (blocs: Array<BlocContent>): any => {
    return blocs.map((blocFigure, index) => <ContentBloc key={index} {...blocFigure} />);
  };

  renderYoutube = () => {
    const { videos } = this.props.joueur;
    return videos.map((c, index) => {
      return (
        <Link key={index} to={`/ffr-tv-player/${c.id}`} className="box card card--video" title="Voir cette vidéo">
          {c.snippet.thumbnails && (c.snippet.thumbnails.standard || c.snippet.thumbnails.high) && (
            <div
              className="card__thumbnail img-blue-dark"
              style={{
                backgroundImage: `url(${
                  c.snippet.thumbnails.standard ? c.snippet.thumbnails.standard.url : c.snippet.thumbnails.high.url
                })`
              }}
            >
              <img
                src={c.snippet.thumbnails.standard ? c.snippet.thumbnails.standard.url : c.snippet.thumbnails.high.url}
                alt=""
              />
            </div>
          )}
          <div className="card__footer">
            <span className="link-icon link-icon--medium is-dark">
              <i className="icon icon-play"></i>
            </span>
            <h5 className="card__title ft-truncat" dangerouslySetInnerHTML={{ __html: c.snippet.description }} />
            <p className="card__date">{c.contentDetails && youtubeDurationToTime(c.contentDetails.duration)}</p>
          </div>
          <div className="card__type">
            <span className="label label--red">{c.snippet.tags && c.snippet.tags[0]}</span>
          </div>
        </Link>
      );
    });
  };
  // TODO : check variable with status
  render() {
    const {
      content,
      poste,
      dateNaissance,
      numInternational,
      taille,
      poids,
      club_formateur,
      logo,
      nom,
      prenom,
      nombre_drops,
      nombre_essais,
      nombre_penalites,
      nombre_selections,
      nombre_transformations,
      annee_premiere_selection,
      joueurs_favs_news,
      videos
    } = this.props.joueur;
    const { data } = this.props;
    if (this.props.joueurStatus === STATUS_DEFAULT) {
      return <Loading />;
    }

    return (
      <>
        <div className="competition-player">
          <section className="section-blueAlt section-competition-player">
            <div className="container">
              <article className="player-detail">
                <div className="player-detail__head">
                  <BackgroundImage className="player-portrait mb-3 mb-md-0" illustration={logo} />
                  <div>
                    <h2 className="mb-1 divided-invert">
                      <span className="first">{nom}</span>
                      <span className="second">{prenom}</span>
                      <span className="third role mb-3 mb-md-2">{poste.name}</span>
                    </h2>
                    <div className="datas-player">
                      <div className="datas-player__row">
                        {taille && taille !== '' && (
                          <div className="data-player__item">
                            <span className="taille ft-h5 key">Taille : </span>
                            <span className="value">{taille}</span>
                          </div>
                        )}
                        {poids && poids !== '' && (
                          <div className="data-player__item">
                            <span className="poids ft-h5 key">Poids : </span>
                            <span className="value">{poids}</span>
                          </div>
                        )}
                        {dateNaissance && dateNaissance !== '' && (
                          <div className="data-player__item">
                            <span className="birthdate ft-h5 key">Né le : </span>
                            <span className="value">{dateNaissance}</span>
                          </div>
                        )}
                      </div>
                      <div className="datas-player__row">
                        {club_formateur && club_formateur !== '' && (
                          <div className="data-player__item">
                            <span className="club_formateur ft-h5 key">Club formateur : </span>
                            <span className="value">{club_formateur}</span>
                          </div>
                        )}
                        {numInternational && numInternational !== '' && (
                          <div className="data-player__item">
                            <span className="number ft-h5 key">N° de joueur : </span>
                            <span className="value">{numInternational}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </section>
          <section className="section section-competition-player_content">
            <div className="content_player">
              <h2 className="mb-3 mt-6">
                À propos de <span className="player__name">{prenom.toLowerCase() + ' ' + nom.toLowerCase()}</span>
              </h2>
              {content.length > 0 && (
                <div className="player__biographie">
                  <h3 className="mb-3 mt-6 title__biographie">
                    Biographie
                    <svg width="22" height="27" viewBox="0 0 22 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.00180938 14.4692C-0.0679335 10.0156 1.87806 5.64799 5.91805 5.50745C9.6476 5.37799 10.6929 8.51658 11.8921 10.1595C12.3761 10.8213 12.8821 11.3971 13.4945 11.4669C14.2991 11.5589 14.8571 10.5522 14.4012 9.27802C14.1145 8.47655 13.3482 6.32766 13.1135 5.29708C12.8983 4.35167 12.7996 3.37389 13.1067 2.62353C12.291 1.78373 12.1107 0.889427 12.0997 0.387764C12.0988 0.32644 12.0997 0.270226 12.1022 0.221678C12.1167 -0.0380965 12.2451 -0.0210621 12.3582 0.0325963C13.0897 0.386912 13.9844 0.421832 15.2857 0.829806C15.4533 0.882613 15.5196 0.788072 15.5511 0.570032C15.5877 0.316219 15.7731 0.346881 15.8547 0.393726C16.775 0.914126 17.6833 1.69941 17.7106 2.36035C18.129 2.47788 18.7559 2.707 19.2721 3.11923C19.3129 3.15159 19.3223 3.20696 19.2619 3.21462C18.3127 3.33897 17.9376 3.77165 17.7973 3.96839C17.7761 3.9982 17.7786 4.04846 17.7939 4.07912C18.0048 4.5399 18.7278 5.08926 18.7082 5.47338C18.6972 5.69568 18.6002 5.86092 18.5994 5.86177C18.9362 6.46308 19.2577 6.68964 19.9721 7.65123C20.2315 8.00044 20.4271 8.28065 20.5496 8.56768C20.6687 8.84534 20.718 9.12726 20.6865 9.48073C20.6865 9.48073 21.9793 10.9534 21.9997 12.7036C22.0176 14.2359 21.0769 16.1173 20.3208 17.3191C19.3835 18.8105 18.8324 19.9807 18.5704 20.806C18.1758 22.0487 17.8517 23.2692 17.7242 24.0094C17.6281 24.5689 17.6085 24.9829 17.6672 25.2503C17.7284 25.5254 18.4233 25.9257 19.3368 26.2639C19.4907 26.3209 19.5383 26.6446 19.5383 26.6488C18.9183 26.5015 17.2002 26.0748 16.627 26.1327C16.411 26.154 16.2536 26.1898 16.1226 26.2341C15.9057 26.3073 15.7663 26.401 15.5647 26.4845C15.563 26.4751 15.5035 26.1736 15.5919 26.056C15.6268 26.0075 15.8692 25.8201 15.9968 25.6557C16.1847 25.413 16.371 25.0638 16.5462 24.5996C16.5266 24.2189 16.257 23.8637 16.2919 23.5716C16.3234 23.3101 16.4705 23.7845 16.8201 23.73C17.0582 22.8647 17.2019 21.8256 17.2589 21.3571C17.4214 20.0403 17.6247 19.0771 17.1747 19.0379C15.5468 18.8965 14.8724 21.404 14.5492 22.7088C14.2464 23.9319 14.1179 24.6277 14.1316 25.0502C14.1401 25.3304 14.2115 25.4905 14.334 25.6055C14.6189 25.8721 14.8936 26.0237 14.9736 26.1165C15.0306 26.183 15.1071 26.441 15.1182 26.5858C15.1122 26.5816 14.7184 26.3601 14.0618 26.303C13.6204 26.2647 13.0522 26.2775 12.5232 26.3678C11.933 26.4674 11.1513 26.6429 11.1513 26.6429C11.1513 26.6429 11.17 26.3218 11.2729 26.2715C11.6923 26.0654 12.1294 25.8763 12.4986 25.5816C12.8983 25.2622 13.0897 24.8449 13.1739 24.6771C13.162 24.2904 12.8456 23.9472 12.9332 23.6133C12.968 23.4796 13.1739 23.9259 13.4852 23.8203C13.8373 22.277 13.8509 20.7737 13.4503 19.5932C13.1917 18.8343 12.9476 18.4715 12.644 18.2807C12.4569 18.1623 12.2196 18.0635 11.893 18.2424C11.5995 18.4042 11.0824 19.0004 11.0101 19.0805C9.95293 20.2439 8.03415 20.5999 7.06201 19.899C7.06201 19.899 7.06201 19.899 7.06115 19.899C7.87085 20.6825 8.73584 20.9943 8.73584 20.9943C8.73584 20.9943 7.73392 21.9048 6.15109 21.5786C5.79813 21.5062 4.99183 21.2941 4.02564 20.7371C4.16852 21.0326 4.36244 21.3103 4.59379 21.5343C5.04456 21.9721 5.30737 22.0308 5.30737 22.0308C1.49703 22.0317 0.043485 17.1624 0.00180938 14.4692Z"
                        fill="#B60718"
                      />
                      <path
                        d="M14.5559 1.96873C13.8755 2.35456 13.6407 2.98824 13.8746 3.64577C13.9605 3.88936 14.0788 4.08015 14.2285 4.22409C13.5038 3.66621 12.8761 2.44059 13.7938 1.78987C14.2004 1.50199 14.6052 1.43045 15.0815 1.41341C15.995 1.3819 16.8872 1.9287 17.315 2.27535C16.7877 1.90145 15.2712 1.56332 14.5559 1.96873Z"
                        fill="#E21F20"
                      />
                      <path
                        d="M15.5986 2.79969C15.5713 2.9811 15.7193 3.1523 15.9303 3.18381C16.1403 3.21447 16.3326 3.09353 16.3598 2.91126C16.3691 2.85505 16.3581 2.80054 16.3368 2.75029C16.3368 2.75029 16.427 2.76988 16.4976 2.79713L16.4312 2.67278C16.2382 2.56376 16.0298 2.51095 15.949 2.49988C15.5152 2.436 15.3477 2.71026 15.3477 2.71026C15.4514 2.68896 15.6334 2.6813 15.6453 2.6813C15.6215 2.71622 15.6054 2.75625 15.5986 2.79969Z"
                        fill="#E21F20"
                      />
                      <path
                        d="M13.2202 15.6253C11.4716 15.3374 10.8065 14.8178 9.14453 14.8102C10.1737 14.6901 10.8753 14.7548 11.7463 14.8212C13.2185 14.9345 14.7631 14.7046 15.7829 14.1015C16.7355 13.5368 17.2186 12.6357 17.057 11.6562C18.8966 13.7361 16.7873 16.2138 13.2202 15.6253Z"
                        fill="#E21F20"
                      />
                      <path
                        d="M18.8404 9.83971C18.9144 8.22399 17.9278 7.88416 17.625 6.94727C18.3114 7.70615 19.1041 8.07068 19.5276 8.77335C20.3764 10.1838 20.0677 11.1147 20.0677 11.1147C19.7675 10.2681 18.8404 9.83971 18.8404 9.83971Z"
                        fill="#E21F20"
                      />
                      <path
                        d="M14.6185 6.04292C14.746 6.82224 15.008 7.16208 16.1826 8.27613C17.1709 9.21387 17.3146 10.1661 17.0935 10.7708C17.6412 9.45746 17.375 8.3102 16.4352 7.01558C15.6595 5.94582 15.48 5.19546 15.503 4.53793C15.1492 4.59755 14.8489 4.54645 14.6763 4.49109C14.6754 4.49109 14.6754 4.49023 14.6746 4.49023C14.6159 4.55411 13.7441 5.53785 14.1728 7.21744C14.3752 8.01039 14.6185 8.60319 14.6355 8.656V8.65685C15.2359 10.2317 15.0658 11.0178 14.7239 11.419C16.2557 10.942 16.112 9.23687 15.3388 7.99677C14.6712 6.9236 14.6253 6.61017 14.6185 6.04292Z"
                        fill="#E21F20"
                      />
                      <path
                        d="M10.8594 16.0372C10.8594 16.0372 13.3055 17.2832 16.1496 16.6019C19.9455 15.6931 19.3952 11.6721 18.2955 11.1074C19.8477 11.1943 21.0572 14.5688 19.0635 16.5695C17.0776 18.5625 13.6993 17.8011 12.0926 16.8131C11.3076 16.331 10.8594 16.0372 10.8594 16.0372Z"
                        fill="#E21F20"
                      />
                      <path
                        d="M4.25867 11.4884C2.85956 12.1953 1.31501 14.1278 1.83553 17.2554C1.88656 17.5603 1.97586 17.8609 2.08813 18.1556C2.09834 18.1803 2.10855 18.205 2.11875 18.2297C2.11875 18.2297 0.791935 16.5092 1.1347 12.9797C1.44684 9.76533 2.98884 7.11563 6.00394 6.94613C8.96036 6.78005 10.3246 9.76533 10.3246 9.76533C10.3246 9.76533 8.70095 7.42565 5.77685 7.92306C3.93547 8.23649 2.96247 10.0098 2.58909 11.4577C3.35371 10.2661 4.4798 9.51492 5.74198 9.4042C8.37095 9.17423 9.70797 10.962 10.9914 11.8572C12.6601 13.0206 14.3561 12.6067 15.0161 12.0352C14.8885 12.4534 13.8645 13.6407 12.1549 13.9311C11.6106 14.0231 10.874 14.0376 9.86617 13.9209C8.08603 13.7156 5.59824 13.4567 4.58442 15.5587C3.56889 17.6616 5.09048 20.0175 7.17426 20.7738C4.76728 20.4587 2.97608 18.2893 3.22613 15.7095C3.58165 12.0505 7.20318 12.1161 9.13217 12.8451C10.0482 13.1901 11.3656 13.3621 11.9193 13.0879C11.9193 13.0879 10.5696 13.0734 9.13047 12.0769C7.84363 11.186 6.21913 10.4987 4.25867 11.4884Z"
                        fill="#E21F20"
                      />
                      <path
                        d="M11.9655 17.7599C10.5562 17.4933 10.028 17.2106 9.47175 16.8554C8.91381 16.4985 8.28442 16.329 7.63887 16.3554C8.67311 15.2644 10.0858 15.7908 10.1198 15.8069C9.53129 15.5173 8.9793 15.1937 8.11601 15.2882C7.16513 15.393 6.77304 16.1238 6.85129 16.7089C7.07242 18.3587 9.71585 17.6748 9.71585 17.6748C9.71585 17.6748 8.77517 18.9021 7.30036 18.661C6.76113 18.5733 6.39455 18.3204 6.16406 17.9967V17.9976C6.64036 18.73 7.35395 19.178 8.59231 19.155C9.78304 19.1346 10.2704 18.6406 11.1039 18.0597C11.3591 17.8843 11.6899 17.7446 11.9655 17.7599Z"
                        fill="#E21F20"
                      />
                    </svg>
                  </h3>
                  {this.renderTrueBlocs(content)}
                </div>
              )}

              <div className="player__statistiques_content">
                <h3 className="mb-3 mt-6 title__statistiques">Statistiques</h3>
                <div className="player__statistiques">
                  <div className="player__statistique">
                    <span className="key">Sélections</span>
                    <span className="value">{nombre_selections}</span>
                  </div>
                  <div className="player__statistique">
                    <span className="key">Essais</span>
                    <span className="value">{nombre_essais}</span>
                  </div>
                  <div className="player__statistique">
                    <span className="key">Pénalités</span>
                    <span className="value">{nombre_penalites}</span>
                  </div>
                  <div className="player__statistique">
                    <span className="key">Drops</span>
                    <span className="value">{nombre_drops}</span>
                  </div>
                  <div className="player__statistique">
                    <span className="key">Transformations</span>
                    <span className="value">{nombre_transformations}</span>
                  </div>
                  <div className="player__statistique">
                    {annee_premiere_selection && (
                      <>
                        <span className="key">Début</span>
                        <span className="value">{annee_premiere_selection}</span>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div>
              {joueurs_favs_news.length > 0 && (
                <div className="sidebar">
                  <h3 className="ft-400" id="actualit-s-associ-es">
                    Actualités associées
                  </h3>
                  {joueurs_favs_news.slice(0, 5).map((news, index) => (
                    <a key={index} className="news news--row-lg" href={news.link}>
                      <a
                        title={`Lire la suite de l'article : ${news.title}`}
                        key={news.id}
                        role="button"
                        tabIndex="0"
                        className="news news--row-lg"
                        href={news.link}
                      >
                        <article>
                          <span className="border" style={{ display: 'none' }}></span>
                          <div
                            className="news__thumbnail img-blue"
                            data-background-type="thumbnail"
                            style={{ backgroundImage: 'url(' + news.illustration + ')' }}
                          ></div>
                          <div>
                            <span className="news__title ft-h4">{news.title}</span>
                            <p className="ft-h6">
                              <span className="news__cat ft-up">{news.label && news.label.name}</span>
                              <span className="news__date">{formatFullDate(new Date(news.date))}</span>
                            </p>
                          </div>
                        </article>
                      </a>
                    </a>
                  ))}
                </div>
              )}
            </div>
          </section>
          {videos.length > 0 && (
            <section className="section container player_youtube_playliste">
              <div className="section-container">
                <div className="top"></div>
                <h2 className="mb-3 divided">
                  <span className="first">{prenom + ' ' + nom}</span>
                  <span className="second">en action</span>
                </h2>
                <div className="news-slider">
                  <div className="news-slider__wrapper news-slider__wrapper--video">{this.renderYoutube()}</div>
                </div>
              </div>
            </section>
          )}
          {joueurs_favs_news.length > 0 && (
            <CompetitionInternationalesArticles
              blockformat={'simple_list'}
              articles={JSON.stringify(
                joueurs_favs_news.map(art => {
                  //$FlowFixMe
                  art.img = art.illustration;
                  return art;
                })
              )}
              title={`Actualités de ${prenom} ${nom}`}
            />
          )}
          {!!data &&
            !!data.content_matchs_resultats &&
            !!data.content_matchs_resultats.data &&
            !!data.content_matchs_resultats.data.length &&
            data.content_matchs_resultats.data.map((bloc, index) => <ContentBloc key={index} {...bloc} />)}
        </div>
      </>
    );
  }
}

export default withHelmet(Joueur)((Helmet, pageProps) => (
  <Helmet>
    <title>{pageProps.joueur.meta_title}</title>
    <meta name={'description'} content={pageProps.joueur.meta_description} />
  </Helmet>
));
